import TextDate from './TextDate'

export default TextDate
